import jQuery from 'jquery';

(($, window, document) => {
  $(document).ready(() => {
    $('.frm__fld--amount.has--refresh-button').each((index, item) => {
      const $elParent = $(item);
      const $elInputField = $elParent.find('input');

      $elInputField.data('lastValue', $elInputField.val());
      $elInputField.on('input change keyup', (event) => {
        const $this = $(event.currentTarget);

        if ($this.data('lastValue') !== $this.val()) {
          $elParent.find('.btn').removeClass('is--disabled');
        } else {
          $elParent.find('.btn').addClass('is--disabled');
        }
      });
    });
  });
})(jQuery, window, document);



// WEBPACK FOOTER //
// ./assets/js/components/reload-button.js